import { useEffect, useState } from 'react';
import {
  QUERY_GET_INPUT_DATA_OF_PERSON,
  removeDataPoint
} from 'services/aws/growthtracker-query';
import { useLazyQuery } from '@apollo/client';
import { TestSetV2Type } from 'constants.js';
import { QUERY_GET_TESTRESULT_TESTS } from 'services/aws/testsets-query';
import TestItemResult from 'models/TestItemResult';

const usePersonInputData = ({ entityId }) => {
  const [personInputData, setPersonInputData] = useState(null);
  const [testItems, setTestItems] = useState([]);
  const [fetchInputDataOfSporter, { loading, error, data, refetch }] =
    useLazyQuery(QUERY_GET_INPUT_DATA_OF_PERSON);
  const [fetchTests] = useLazyQuery(QUERY_GET_TESTRESULT_TESTS, {
    variables: { type: TestSetV2Type.TALENT, entityId: entityId }
  });

  useEffect(() => {
    if (data?.getInputData) {
      parseData(data.getInputData);
    }
  }, [data, testItems]);

  const parseData = data => {
    const bundled = data.reduce((acc, obj) => {
      if (!acc[obj.testDateTime]) {
        acc[obj.testDateTime] = {};
      }
      // search the testitem in the test array
      const testItem = testItems.find(t => t.id === obj.testItemId);

      if (testItem) {
        const objValues = obj.values || [];
        let values;
        if (testItem.hidden) {
          return acc; // Skip hidden test items
        }
        if (testItem.input_type === 'select_with_options') {
          values = objValues.map(v => {
            if (typeof v !== 'undefined') {
              const option = testItem.input_type_parameters.options.find(
                o => o.value === v
              );
              if (option) {
                return (v = option.label);
              }
              return v;
            }
            return v;
          });
        } else {
          values = objValues.map(v =>
            typeof v !== 'undefined' ? Number(parseFloat(v).toPrecision(4)) : v
          );
        }
        acc[obj.testDateTime][obj.testItemId] = {
          id: obj.id,
          testName: testItem.title,
          testItemId: obj.testItemId,
          values: values
        };
      } else {
        console.log(
          `TestItem with ID ${obj.testItemId} not found in testItems array`
        );
      }

      return acc;
    }, {});

    setPersonInputData(bundled);

    return bundled;
  };

  const fetchInputData = async ({ personId }) => {
    const { data: testsData } = await fetchTests();
    const { data } = await fetchInputDataOfSporter({
      variables: {
        personId
      },
      fetchPolicy: 'cache-and-network'
    });

    if (testsData?.getTests) {
      const tests = testsData.getTests;
      const testItems = tests.flatMap(test =>
        test.testItems.map(item => ({
          ...new TestItemResult({ ...item })
        }))
      );
      setTestItems(testItems);
    }

    if (data?.getInputData) {
      return parseData(data.getInputData);
    }
  };

  const deleteDataPoint = async id => {
    return new Promise(async resolve => {
      const result = await removeDataPoint(id);
      if (result) {
        resolve(true);
      }
    });
  };

  return {
    fetchInputData,
    deleteDataPoint,
    personInputData,
    loading,
    error,
    refetch
  };
};

export default usePersonInputData;
